export const handleAuthError = (error: any) => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    console.error("Authentication failed. Please login again.");

    localStorage.removeItem("authCred");
    localStorage.removeItem("authResponse");
    localStorage.removeItem("authTimestamp");
    localStorage.removeItem("authExpiryTime");
    localStorage.removeItem("lastActivityTime");
    localStorage.removeItem("selectedTenantId");
    localStorage.removeItem("lifecycleTypeNames");
    localStorage.removeItem("avatar_url");
    localStorage.removeItem("isTeamManager");
    localStorage.removeItem("currency_code");

    throw new Error("Authentication failed. Please login again.");
  }
  throw error;
};

export const getAuthHeaders = () => {
  const authCred = localStorage.getItem("authCred");

  if (!authCred) {
    throw new Error("Authentication required. Please login first.");
  }

  const lastActivityTime = localStorage.getItem("lastActivityTime");
  if (lastActivityTime) {
    const timeSinceLastActivity = Date.now() - Number(lastActivityTime);
    if (timeSinceLastActivity > 24 * 60 * 60 * 1000) {
      localStorage.removeItem("authCred");
      localStorage.removeItem("authResponse");
      localStorage.removeItem("authTimestamp");
      localStorage.removeItem("authExpiryTime");
      localStorage.removeItem("lastActivityTime");
      localStorage.removeItem("selectedTenantId");
      localStorage.removeItem("lifecycleTypeNames");
      localStorage.removeItem("avatar_url");
      localStorage.removeItem("isTeamManager");
      localStorage.removeItem("currency_code");
      throw new Error("Session expired due to inactivity. Please login again.");
    }

    const now = Date.now();
    localStorage.setItem("lastActivityTime", now.toString());
    const newExpiryTime = now + (24 * 60 * 60 * 1000);
    localStorage.setItem("authExpiryTime", newExpiryTime.toString());
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Basic ${authCred}`,
  };
};
